export const SIDE_DOCK_WIDTH = 500;
export const ANIMATION_DURATION = 500;